/**
 * Hosts whose links this app is allowed to take over. The manifest already narrows what the
 * system hands us (teamplay.gg only), so this is the second line: a URL arriving from anywhere
 * else must never be turned into in-app navigation.
 *
 * dev is here so a native dev build can open a link from the environment it talks to; the
 * manifest doesn't claim it, because its assetlinks.json sits behind basic auth and could
 * never verify.
 */
const APP_LINK_HOSTS = new Set(['teamplay.gg', 'www.teamplay.gg', 'dev.teamplay.gg']);

/**
 * The in-app path for an incoming Android App Link / iOS Universal Link, or null when the URL
 * is not one of ours to handle.
 *
 * Only the path travels: the native shell serves the app from https://localhost, so loading the
 * absolute URL would leave the app and open the website instead.
 *
 * Custom-scheme deep links (gg.teamplay.twa://…) return null on purpose — they belong to the
 * OAuth, push-tap and call listeners, which are subscribed to the same appUrlOpen event.
 */
export const appLinkPath = (url: string | null | undefined): string | null => {
  if (!url) {
    return null;
  }

  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return null;
  }

  if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') {
    return null;
  }

  if (!APP_LINK_HOSTS.has(parsed.host)) {
    return null;
  }

  return `${parsed.pathname}${parsed.search}`;
};
